import { render, staticRenderFns } from "./VisitsSchedule.vue?vue&type=template&id=6980e1bc&"
import script from "./VisitsSchedule.vue?vue&type=script&lang=js&"
export * from "./VisitsSchedule.vue?vue&type=script&lang=js&"
import style0 from "./VisitsSchedule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports